import {
  DeleteSupportingDoc,
  DeleteSupportingDocVariables,
} from "_graphql/mutation/__generated__/DeleteSupportingDoc";
import { FileText, Trash } from "lucide-react";

import { Show } from "components";
import { removeOfferSupportingDocument } from "_graphql/visal/mutations/offers";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";

type Props = {
  documentName: string;
  offerId: string;
};

const SupportingDocument = ({ documentName, offerId }: Props) => {
  const [removeItem, { loading }] = useMutation<
    DeleteSupportingDoc,
    DeleteSupportingDocVariables
  >(removeOfferSupportingDocument, {
    refetchQueries: ["GetSupportingDocsList"],
    awaitRefetchQueries: true,
  });
  const handleRemoveDocument = (doc: string) => () => {
    removeItem({
      variables: {
        offerId: offerId,
        filename: doc,
      },
      onCompleted: () => {
        toast.success("Document removed successfully");
      },
      onError: (error) => {
        toast.error("Could not remove document");
      },
    });
  };

  return (
    <li className="flex items-center justify-between p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition">
      <div className="flex items-center gap-3">
        <FileText className="w-5 h-5 text-gray-500" />
        <span className="text-sm font-medium text-gray-800">
          {documentName}
        </span>
      </div>
      <button
        disabled={loading}
        onClick={handleRemoveDocument(documentName as string)}
        rel="noopener noreferrer"
        className="text-red-600 disabled:cursor-not-allowed hover:underline flex items-center gap-1 text-sm"
      >
        <Show if={!loading}>
          <>
            <Trash className="w-4 h-4" />
            Remove
          </>
        </Show>
        <Show if={loading}>
          <span>Removing document...</span>
        </Show>
      </button>
    </li>
  );
};

export default SupportingDocument;
